import type { TOC } from '@ember/component/template-only'
import { t } from 'ember-intl'
import RouteTemplate from 'ember-route-template'
import UiButtonLinkTo from 'teacher-ui-client/components/ui-button/link-to'
import { ButtonAppearance } from 'teacher-ui-client/components/ui-button/themes'
import type WritingLegendsVocabularyBankRoute from 'teacher-ui-client/reporting/ui-scope/writing-legends/vocabulary/bank/route'

interface Signature {
  Args: {
    model: ModelFor<WritingLegendsVocabularyBankRoute>
  }
}

export const WritingLegendsVocabularyBankPage: TOC<Signature> = <template>
  <div class="flex w-full flex-col items-center p-4">
    <div class="inline-flex" data-test-table-or-chart-selector-container>
      <UiButtonLinkTo
        data-test-table-or-chart-selector="chart"
        class="rounded-r-none"
        @route="reporting.ui-scope.writing-legends.vocabulary.bank.new-words"
        @appearance={{ButtonAppearance.mutedWithActive}}
      >
        {{t "pages.wlVocabulary.bank.tabs.newWords"}}
      </UiButtonLinkTo>
      <UiButtonLinkTo
        data-test-table-or-chart-selector="table"
        class="rounded-l-none"
        @route="reporting.ui-scope.writing-legends.vocabulary.bank.language-gems"
        @appearance={{ButtonAppearance.mutedWithActive}}
      >
        {{t "pages.wlVocabulary.bank.tabs.languageGems"}}
      </UiButtonLinkTo>
    </div>
  </div>

  {{outlet}}
</template>

export default RouteTemplate(WritingLegendsVocabularyBankPage)
